export class UserAction {
    constructor (data) {
        if (data) {
            this.clientId = data.clientId ? data.clientId : ''
            this.clientNumber = data.clientNumber ? data.clientNumber : ''
            this.userId = data.userId ? data.userId : ''
            this.userNumber = data.userNumber ? data.userNumber : ''
            this.action = data.action ? data.action : 0
            this.interval = data.interval ? data.interval : 0
        } else {
            this.clientId = ''
            this.clientNumber = ''
            this.userId = ''
            this.userNumber = ''
            this.action = 0
            this.interval = 0
        }
    }
}
